import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newburghConfig } from "./data";

export default function NewburghPage() {
  return <CityPageTemplate config={newburghConfig} />;
}